var pack_limit = 2; //
var pack_no = 0;
var total_price = 0;
var sub_price = 0;
var subscribed = false;
var images = new Object();
images["2pack"] =
  "https://cdn.shopify.com/s/files/1/0352/0806/9255/files/imgpsh_fullsize_anim_1.png?v=1648459565";
images["4pack"] =
  "https://cdn.shopify.com/s/files/1/0352/0806/9255/files/imgpsh_fullsize_anim_2.png?v=1648459565";
images["6pack"] =
  "https://cdn.shopify.com/s/files/1/0352/0806/9255/files/imgpsh_fullsize_anim.png?v=1648459565";
images["8pack"] =
  "https://cdn.shopify.com/s/files/1/0352/0806/9255/files/imgpsh_fullsize_anim_3.png?v=1648459565";
images["16pack"] =
  "https://cdn.shopify.com/s/files/1/0352/0806/9255/files/imgpsh_fullsize_anim_4.png?v=1648459566";

function storeMore(pack) {
  if ($(window).width() > 991) {
    var x = document.querySelectorAll("#ProductImagesDesktop .imgWrap");
  } else {
    var x = document.querySelectorAll("#ProductImagesMobile .prodt .imgWrap");
  }

  var y = [];
  if (x.length != 0) {
    for (var i = 0; i < pack; i++) {
      y[i] = x[i].getAttribute("data-product-id");
    }
  }
  return y;
}

function storeLess(pack, pckcount) {
  if ($(window).width() > 991) {
    var x = document.querySelectorAll("#ProductImagesDesktop .imgWrap");
  } else {
    var x = document.querySelectorAll("#ProductImagesMobile .prodt .imgWrap");
  }

  var y = [];
  let loop = 0;
  if (pckcount < pack) {
    loop = pckcount;
  } else {
    loop = pack;
  }

  if (x.length != 0) {
    for (var i = 0; i < loop; i++) {
      y[i] = x[i].getAttribute("data-product-id");
    }
  }
  return y;
}

function stockBack(stock) {
  if (stock.length != 0) {
    stock.forEach((i) => {
      $(".product").each(function () {
        if ($(this).attr("data-id") == i) {
          if ($(this).find(".add-wrapper").css("display") == "block") {
            $(this).find(".add-button").trigger("click");
          } else {
            $(this).find(".plus-select").trigger("click");
          }
        }
      });
    });
  }
}

function countProducts() {
  let c = 0;
  if ($(window).width() > 991) {
    document.querySelectorAll("#ProductImagesDesktop .imgWrap").forEach((i) => {
      c++;
    });
  } else {
    document
      .querySelectorAll("#ProductImagesMobile .prodt .imgWrap")
      .forEach((i) => {
        c++;
      });
  }

  return c;
}

function itemReset(less, afterPack, beforePack) {
  let prodCount = countProducts();

  let storeArr = [];

  if (!less) {
    storeArr = storeMore(prodCount);
  } else {
    storeArr = storeLess(prodCount, afterPack);
  }

  $("#ProductImagesDesktop .imgWrap").each(function () {
    $(this).find(".closeBtn").trigger("click");
  });
  $("#ProductImagesMobile .prodt .imgWrap").each(function () {
    $(this).find(".closeBtn").trigger("click");
  });

  window.pack_no = 0;
  window.total_price = 0;
  window.sub_price = 0;
  $(".product").find("input").val(0);
  $(".product").find("input").attr("value", 0);
  $(".product").attr("data-product-quantity", 0);

  $(".stock").each(function () {
    if ($(this).hasClass("less16")) {
      var x = $(this).closest(".product").attr("data-stock-left");
      $(this).text("Only " + x + " Left!");
    }
  });

  stockBack(storeArr);
}
function stockMessage(el, left, count) {
  if (count != left) {
    $(el[1]).prev().removeClass("dontchange").prop("disabled", false);
    el.text("Only " + parseInt(left - count) + " Left!");
  } else {
    $(el[1]).prev().addClass("dontchange").prop("disabled", true);
    el.text("Out of Stock");
  }
}

function changePrice(main, sub, plus) {
  if (plus == true) {
    window.total_price = window.total_price + main / 100;
    window.sub_price = window.sub_price + sub / 100;
  } else {
    window.total_price = window.total_price - main / 100;
    window.sub_price = window.sub_price - sub / 100;
  }
  //console.log('sub' + window.sub_price + 'main' + window.total_price );
  if (window.total_price > 0) {
    $('.empty-text').hide();
    $('#ProductImagesDesktop').addClass('productAdded');
    if (!window.subscribed) {
      $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).show();});
      $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).text("$" + window.total_price.toFixed(2));});
      $(".price-wrapper .sub-price,.option_wrapper .sub-price").each(function(){$(this).show();});
      $(".price-wrapper .sub-price,.option_wrapper .sub-price").each(function(){$(this).text("$" + window.sub_price.toFixed(2));});
      $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).removeClass("crossed");});
      $(".floating_mobile_atc .sub-price").hide();
    } else {
      $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).show();});
      $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).text("$" + window.total_price.toFixed(2));});
      $(".price-wrapper .sub-price,.option_wrapper .sub-price").each(function(){$(this).show();});
      $(".price-wrapper .sub-price,.option_wrapper .sub-price").each(function(){$(this).text("$" + window.sub_price.toFixed(2));});
      $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).addClass("crossed");});
      $(".floating_mobile_atc .sub-price").show();
    }
  } else {
    $('.empty-text').show();
    $('#ProductImagesDesktop').removeClass('productAdded');
    $(".price-wrapper .og-price,.option_wrapper .og-price").each(function(){$(this).hide();});
    $(".price-wrapper .sub-price,.option_wrapper .sub-price").each(function(){$(this).hide();});
  }
}

function checkQuant() {
  if (window.pack_no >= window.pack_limit) {
    $(".plus-select").each(function () {
      if (!$(this).hasClass("dontchange")) {
        $(this).prop("disabled", true);
      }
    });

    $(".add-wrapper .add-button").each(function () {
      if (!$(this).hasClass("fully-disabled")) {
        $(this).prop("disabled", true);
      }
    });

    $(".atc-wrapper .atc").prop("disabled", false);
  } else {
    $(".plus-select").each(function () {
      if (!$(this).hasClass("dontchange")) {
        $(this).prop("disabled", false);
      }
    });

    $(".add-wrapper .add-button").each(function () {
      if (!$(this).hasClass("fully-disabled")) {
        $(this).prop("disabled", false);
      }
    });

    $(".atc-wrapper .atc").prop("disabled", true);
  }
}

function reduce(el) {
  if ($(el).parent().hasClass("imgWrap")) {
    var id = "product-" + $(el).parent().attr("data-product-id");

    $(el).parent().remove();
    $(".product").each(function () {
      if ($(this).attr("id") == id) {
        var left = parseInt($(this).attr("data-stock-left"));
        var count = parseInt($(this).attr("data-product-quantity")) - 1;
        changePrice(
          parseInt($(this).attr("data-price")),
          parseInt($(this).attr("data-sub-price")),
          false
        );
        $(this).attr("data-product-quantity", count);
        let st = $(this).find(".stock");
        if (st.hasClass("less16")) {
          stockMessage(st, left, count);
        }
        var inp = $(this).find("input");
        if (inp.attr("value") == "1") {
          inp.attr("value", 0);
          inp.closest('.quantity-box').css("display", "none");
          inp.closest('.quantity-box').prev().css("display", "block");
        } else {
          var c = parseInt(inp.attr("value"));
          inp.attr("value", c - 1);
          inp.val(c - 1);
        }
      }
    });
  }
  if ($(el).hasClass("minus-select")) {
    var main_parent = $(el).closest(".product");
    var left = parseInt(main_parent.attr("data-stock-left"));
    var count = parseInt(main_parent.attr("data-product-quantity")) - 1;
    main_parent.attr("data-product-quantity", count);
    let st = main_parent.find(".stock");
    if (st.hasClass("less16")) {
      stockMessage(st, left, count);
    }
    changePrice(
      parseInt(main_parent.attr("data-price")),
      parseInt(main_parent.attr("data-sub-price")),
      false
    );
    var id = main_parent.attr("data-id");
    $("#ProductImagesDesktop .imgWrap").each(function () {
      if ($(this).attr("data-product-id") == id) {
        $(this).remove();
        return false;
      }
    });
    $("#ProductImagesMobile .prodt .imgWrap").each(function () {
      if ($(this).attr("data-product-id") == id) {
        $(this).remove();
        return false;
      }
    });
  }
  window.pack_no--;
  checkQuant();
  if(pack_no > 0){
    $('.price-wrapper').show();
  }else{
    $('.price-wrapper').hide();
  }
}

function increaseQuant(el) {
  var main_parent = $(el).closest(".product");
  var subStatus = main_parent.attr("data-subp-m1-id") == "" ? false : true;
  var left = parseInt(main_parent.attr("data-stock-left"));
  var count = parseInt(main_parent.attr("data-product-quantity")) + 1;
  main_parent.attr("data-product-quantity", count);
  let st = main_parent.find(".stock");
  if (st.hasClass("less16")) {
    stockMessage(st, left, count);
  }
  changePrice(
    parseInt(main_parent.attr("data-price")),
    parseInt(main_parent.attr("data-sub-price")),
    true
  );
  var source = main_parent.find("img").attr("src");
  var id = main_parent.data("id");
  var img_wrapper =
    '<div class="imgWrap" data-sub-status=' +
    subStatus +
    ' data-product-id="' +
    id +
    '"><div class="closeBtn" onclick="reduce(this)">X</div><img src="' +
    source +
    '""></div>';
  $(".prodt").append(img_wrapper);
  $(".prodtBX").append(img_wrapper);

  window.pack_no++;

  checkQuant();
  if(pack_no > 0){
    $('.price-wrapper').show();
  }else{
    $('.price-wrapper').hide();
  }
}

function addItemToCart(items, gm) {
  const loader_svg = 'Added';
    if (gm != "") {
    data = {
      items: items,
      properties: {
        "Gift Message": gm,
      },
    };
  } else {
    data = {
      items: items
    };
  }
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    async: false,
    success: function () {
      console.log("%cProducts are Successfully Added to Cart", "color:green");
      $(".atc-wrapper .atc").html(loader_svg);
      //window.location.href = '/cart';
    },
    error: function () {
      console.log(
        "%cSomething Went Wrong, Product was not added to cart",
        "color:red"
      );
    },
  });
}

$(document).ready(function () {
  
  setTimeout(function () {
    $(".ptitle").next().addClass("okendo-review-snippet");
    $(".okendo-review-snippet").click(function () {
      var id = $(this).attr("data-modal-id");
      $(".product-details-modal").each(function () {
        if ($(this).attr("id") == id) {
          $(this).show();
        }
      });
    });
  }, 2500);

  setTimeout(function(){
    let currentCurrency = $('.mlcurrent').text();
    if(currentCurrency == "USD"){
      $('.product').each(function(){
        let onePrice = $(this).data('price');
        let subPrice = $(this).data('subPrice');
        onePrice = parseFloat($(this).find('.money').data('currencyUsd').split('$')[1])*100;
        subPrice = parseFloat($(this).find('.money').data('currencyUsd').split('$')[1])*80;
        //subPrice = subPrice - subPrice*0.2;
        $(this).attr('data-price',onePrice);
        $(this).attr('data-sub-price',subPrice);
      });
    }
  },3000)

  if ($(window).width() > 992) {
    $("input:radio[name='plan-selector']").eq(0).trigger("click");
  }
  jQuery(document).ready(function () {
    // This button will increment the value
    $(".qtyplus").click(function (e) {
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).data("field");
      // Get its current value
      var currentVal = parseInt($("input[name=" + fieldName + "]").val());
      // If is not undefined
      increaseQuant(this);
      if (!isNaN(currentVal)) {
        // Increment
        $("input[name=" + fieldName + "]").val(currentVal + 1);
        $("input[name=" + fieldName + "]").attr("value", currentVal + 1);
      } else {
        // Otherwise put a 0 there
        $("input[name=" + fieldName + "]").val(0);
        $("input[name=" + fieldName + "]").attr("value", 0);
      }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function (e) {
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).data("field");
      // Get its current value
      var currentVal = parseInt($("input[name=" + fieldName + "]").val());
      // If it isn't undefined or its greater than 0

      reduce(this);

      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        $("input[name=" + fieldName + "]").val(currentVal - 1);
        $("input[name=" + fieldName + "]").attr("value", currentVal - 1);
      } else {
        // Otherwise put a 0 there
        $("input[name=" + fieldName + "]").val(0);
        $("input[name=" + fieldName + "]").attr("value", 0);

        console.log($(this).closest('.quantity-box').prev());
        
        $(this).closest('.quantity-box').css("display", "none");
        $(this).closest('.quantity-box').prev().css("display", "block");
        //$('.price-wrapper h3').css('display', 'none');
      }
    });
  });

  $(".view-button").click(function () {
    var id = $(this).attr("data-modal-id");
    $(".product-details-modal").each(function () {
      if ($(this).attr("id") == id) {
        $(this).show();
      }
    });
    $("html").addClass("pdmodal_show");
  });

  $(".CLB-Modal").click(function () {
    $(this).parent().removeClass("show-modal").addClass("hide-modal");
    $(".product-details-modal").hide();
    $("html").removeClass("pdmodal_show");
  });

  $(".button-wrap button").click(function () {
    increaseQuant(this);

    $(this).closest(".add-wrapper").next().find("input").attr("value", 1);
    $(this).closest(".add-wrapper").next().find("input").val(1);
    $(this).closest(".add-wrapper").next().css("display", "block");
    $(this).closest(".add-wrapper").css("display", "none");
  });
  $(".build-box-wrapper .placeholder-product-image").attr(
    "src",
    images["2pack"]
  );

  $(".pack").click(function () {
    if (
      window.pack_limit >
      parseInt($(this).find(".toggle-text").attr("data-pack"))
    ) {
      itemReset(
        true,
        parseInt($(this).find(".toggle-text").attr("data-pack")),
        window.pack_limit
      );
    } else if (
      window.pack_limit <
      parseInt($(this).find(".toggle-text").attr("data-pack"))
    ) {
      itemReset(
        false,
        parseInt($(this).find(".toggle-text").attr("data-pack")),
        window.pack_limit
      );
    }

    $(".pack").removeClass("active");
    $(this).addClass("active");
    var pck = $(this).find(".toggle-text").attr("data-pack");

    //For Desktop

    $("#ProductImagesDesktop").parent()[0].className = "";
    $("#ProductImagesDesktop").parent().addClass("content-wrapper desktop");
    $("#ProductImagesDesktop")
      .parent()
      .addClass("pkg" + pck);

    //For Mobile

    $("#ProductImagesMobile")[0].className = "";
    $("#ProductImagesMobile").addClass("mobile_product_images");
    $("#ProductImagesMobile").addClass("pkg" + pck);

    $(".build-box-wrapper .placeholder-product-image").attr(
      "src",
      images[pck + "pack"]
    );

    window.pack_limit = parseInt(pck);
    checkQuant();
  });

  $("input:checkbox[name='plan-selector']").change(function () {
    let check = $(this).prop("checked");
    let text = $(this).parent().next();
    if (check) {
      text.text("SUBSCRIBE & SAVE (20%)");
      $('.data-shipment-text').show();
      if (window.total_price != 0) {
        $(".price-wrapper .og-price").text("$" + window.total_price.toFixed(2));
        $(".price-wrapper .sub-price").text("$" + window.sub_price.toFixed(2));
        $(".price-wrapper .og-price").addClass("crossed");
        $(".price-wrapper .sub-price").show();
      }

      $(".subscribe-price").show();
      $(".one-time-price").hide();
      $(".sub-choice").removeClass('subdrop-disabled').show();
      $(".submessage").show();
      $('.og-price.subbed').show();
      window.subscribed = true;
      $("#ProductImagesDesktop .imgWrap").each(function () {
        if ($(this).attr("data-sub-status") == "false") {
          $(this).find(".closeBtn").trigger("click");
        }
      });
      $('#ProductImagesMobile .imgWrap').each(function(){
        if ($(this).attr("data-sub-status") == "false") {
          $(this).remove();
        }
      });
      $(".product").each(function () {
        let btn = $(this).find(".add-button");
        let subStat = $(this).attr('data-subp-m1-id') === '';
        if (btn.hasClass("sub-disabled") && pack_limit != pack_no) {
          btn.addClass("fully-disabled");
          btn.prop("disabled", true);
        }
        if(subStat){
          $(this).find('.no-sub').fadeIn(500);
          btn.addClass("fully-disabled");
          btn.prop("disabled", true);
        }
        btn.next().show();
      });
    } else {
      text.text("ONE-TIME PURCHASE");
      $('.data-shipment-text').hide();
      if (window.total_price != 0) {
        $(".price-wrapper .og-price").text("$" + window.total_price.toFixed(2));
        $(".price-wrapper .sub-price").text("$" + window.sub_price.toFixed(2));
        $(".price-wrapper .og-price").removeClass("crossed");
        $(".price-wrapper .sub-price").hide();
      }
      $(".subscribe-price").hide();
      $(".one-time-price").show();
      $(".sub-choice").addClass('subdrop-disabled').hide();
      $(".submessage").hide();
      $('.og-price.subbed').hide();
      window.subscribed = false;
      $(".product").each(function () {
        let btn = $(this).find(".add-button");
        let subStat = $(this).attr('data-subp-m1-id') === '';
        if (btn.hasClass("sub-disabled") && pack_limit != pack_no) {
          btn.removeClass("fully-disabled");
          btn.prop("disabled", false);
        }
        if(subStat){
          $(this).find('.no-sub').fadeOut(500);
          btn.removeClass("fully-disabled");
          btn.prop("disabled", false);
        }
        btn.next().hide();
      });
    }
  });

  $("input:radio[name='plan-selector']").change(function () {
    var _val = $(this).val();
    $("input:radio[name='plan-selector']").removeAttr("checked");
    $(this).attr("checked", "checked");
    if (_val == "Subscribe") {
      $('.data-shipment-text').show();
      if (window.total_price != 0) {
        $(".price-wrapper .og-price").text("$" + window.total_price.toFixed(2));
        $(".price-wrapper .sub-price").text("$" + window.sub_price.toFixed(2));
        $(".price-wrapper .og-price").addClass("crossed");
        $(".price-wrapper .sub-price").show();
        $('.og-price.subbed').show();
      }

      $(".subscribe-price").show();
      $(".one-time-price").hide();
      $(".sub-choice").removeClass('subdrop-disabled').show();
      $(".submessage").show();
      
      window.subscribed = true;
      $("#ProductImagesDesktop .imgWrap").each(function () {
        if ($(this).attr("data-sub-status") == "false") {
          $(this).find(".closeBtn").trigger("click");
        }
      });
      $('#ProductImagesMobile .imgWrap').each(function(){
        if ($(this).attr("data-sub-status") == "false") {
          $(this).remove();
        }
      });
      $(".product").each(function () {
        let btn = $(this).find(".add-button");
        let subStat = $(this).attr('data-subp-m1-id') === '';
        if (btn.hasClass("sub-disabled") && pack_limit != pack_no) {
          btn.addClass("fully-disabled");
          btn.prop("disabled", true);
        }
        if(subStat){
          $(this).find('.no-sub').fadeIn(500);
          btn.addClass("fully-disabled");
          btn.prop("disabled", true);
        }
        btn.next().show();
      });
      
    }
    if (_val == "One-Time") {
      $('.data-shipment-text').hide();
      if (window.total_price != 0) {
        $(".price-wrapper .og-price").text("$" + window.total_price.toFixed(2));
        $(".price-wrapper .sub-price").text("$" + window.sub_price.toFixed(2));
        $(".price-wrapper .og-price").removeClass("crossed");
        $(".price-wrapper .og-price").show();
        $(".price-wrapper .sub-price").hide();
        $('.og-price.subbed').hide();
      }
      $(".subscribe-price").hide();
      $(".one-time-price").show();
      $(".sub-choice").addClass('subdrop-disabled').hide();
      $(".submessage").hide();
      
      window.subscribed = false;
      $(".product").each(function () {
        let btn = $(this).find(".add-button");
        let subStat = $(this).attr('data-subp-m1-id') === '';
        if (btn.hasClass("sub-disabled") && pack_limit != pack_no) {
          btn.removeClass("fully-disabled");
          btn.prop("disabled", false);
        }
        if(subStat){
          $(this).find('.no-sub').fadeOut(500);
          btn.removeClass("fully-disabled");
          btn.prop("disabled", false);
        }
        btn.next().hide();
      });
    }
  });
  $("#MainFilter").change(function () {
    var value = $(this).val();
    if (value == "all") {
      $(".product").each(function () {
        $(this).show();
      });
    } else {
      $(".product").each(function () {
        $(this).show();
      });
      $(".product").each(function () {
        if (!$(this).attr("data-category").includes(value)) {
          $(this).hide();
        }
      });
    }
  });
  $(".atc-wrapper .atc").click(function () {
    var products = [];
    var gm = $(".gift-note:first").val() + $(".gift-note:last").val();
    $(this).prop("disabled", true);
    if (!window.subscribed) {
      $(".product").each(function () {
        if (parseInt($(this).attr("data-product-quantity")) > 0) {
          let obj = {id: parseInt($(this).attr("data-var-id")),quantity: parseInt($(this).attr("data-product-quantity"))};
          products.push(obj);
          //var t = [parseInt($(this).attr('data-var-id')), parseInt($(this).attr('data-product-quantity'))];
          //products.push(t);
        }
      });
      addItemToCart(products,gm);
      //products.forEach(i => { addItemToCart(i[0],i[1],gm); });
      window.location.href = "/cart";
      //console.log(products);
    } else {
      $(".product").each(function () {
        var plan = 0;
        var selector = "";
        if ($(window).width() > 992) {
          selector = $(".sub-choice-selectors");
        } else {
          selector = $(".sub-choice-selectors#MobileChoice");
        }
        if (selector.val() == "1m") {
          plan = parseInt($(this).attr("data-subp-m1-id"));
        }
        if (selector.val() == "2m") {
          plan = parseInt($(this).attr("data-subp-m2-id"));
        }
        if (selector.val() == "3m") {
          plan = parseInt($(this).attr("data-subp-m3-id"));
        }
        if (parseInt($(this).attr("data-product-quantity")) > 0) {
          let obj = {id: parseInt($(this).attr("data-var-id")), quantity: parseInt($(this).attr("data-product-quantity")), selling_plan: plan}
          products.push(obj);
          //var t = [parseInt($(this).attr('data-var-id')), parseInt($(this).attr('data-product-quantity')), parseInt($(this).attr('data-subp-id'))];
          //products.push(t);
        }
      });
      addItemToCart(products,gm);
      //products.forEach(i => { addItemToCartsub(i[0],i[1],i[2],gm); });
      window.location.href = "/cart";
      //console.log(products);
    }
  });

  $(".product-image-thumb-slider img").click(function () {
    var source = $(this).attr("src");
    $(this).parent().parent().parent().parent().prev().find("img").attr("src", source);
  });

  $("i").each(function () {
    if ($(this).text() == "SHIPPING IS ALWAYS FREE WITH ORDERS OVER $50!") {
      $(this).hide();
    }
  });

  document.querySelectorAll("p").forEach((i) => {
    if (i.textContent == "" || i.textContent == "&nbsp;") {
      i.style.display = "none";
    }
  });
});
